import { render } from "./AdvancedMenu.vue?vue&type=template&id=62ffded5"
import script from "./AdvancedMenu.vue?vue&type=script&lang=js"
export * from "./AdvancedMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__